import { useEffect, useState } from "react";
import isEmpty from "lodash-es/isEmpty";
import { useMutation } from "@apollo/client";

import { REFRESH_TOKEN } from "graphqlQueries/auth";
import { refreshAuthMapper } from "graphqlQueries/auth.map";

import {
  getRefreshTokenFromStorage,
  setAuthInfoToStorage,
  clearAuthInfoFromLocalStorage,
} from "utils/jwtUtils";

export const useRefreshToken = () => {
  const [mutation] = useMutation(REFRESH_TOKEN, {});
  const [loading, setLoading] = useState(true);
  const refreshToken = getRefreshTokenFromStorage();

  useEffect(() => {
    if (!refreshToken) {
      setLoading(false);
      return;
    }
    const refresh = async () => {
      const { data, errors } = await mutation({
        variables: { refresh_token: refreshToken },
      });
      if (!isEmpty(errors)) {
        clearAuthInfoFromLocalStorage();
        return;
      }
      setAuthInfoToStorage(refreshAuthMapper(data));
    };
    refresh().then(() => setLoading(false));
  }, []);

  return { isRefreshLoading: loading };
};
